import { useEffect } from 'react';
import { useBlocker } from 'react-router';

// In-app navigation to another page waits on the returned blocker until the
// user confirms or cancels; closing or reloading the tab gets the browser's
// own prompt. A change of the page's own address, such as its search, is the
// page's to handle.
export const useUnsavedChangesGuard = (unsaved: boolean) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      unsaved && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    if (!unsaved) {
      return;
    }
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [unsaved]);

  // Saved meanwhile: nothing is lost any more, so the navigation stays here
  // and the question goes away.
  useEffect(() => {
    if (blocker.state === 'blocked' && !unsaved) {
      blocker.reset();
    }
  }, [blocker, unsaved]);

  return blocker;
};
